// @ts-nocheck
/* eslint-disable react/display-name */
import React from 'react';
// TODO: Use new button
// eslint-disable-next-line import-path/forbidden
import Button from 'design-system/ButtonLegacy';
import InputGroup from 'design-system/InputGroup';
import InputPrepend from 'design-system/InputPrepend';
import InputText from 'design-system/InputText';
import Label from 'design-system/Label';
import InputCheckbox from 'design-system/InputCheckbox';
import InputRadio from 'design-system/InputRadio';
import Select from 'design-system/SelectInput';
import Textarea from 'design-system/Textarea';
import PropTypes from 'prop-types';

/** @deprecated - don't need to use form elements */
class Form extends React.Component<any> {
  static propTypes = {
    mode: PropTypes.string,
  };

  static defaultProps = {
    mode: 'horizontal',
  };

  render() {
    const { mode, children, ...restProps } = this.props;
    const className = mode === 'vertical' || mode === 'grid' ? mode : 'horizontal';

    return (
      <form {...restProps} className={className}>
        {children}
        <style jsx>{`
          form {
            display: grid;
            width: 100%;
            grid-column-gap: 10px;
            grid-row-gap: 20px;
            align-items: center;
            grid-column-end: 1;
            max-width: 500px;
            line-height: 2;
          }
          form.horizontal {
            grid-template-columns: 140px auto;
            grid-row-gap: 20px;
          }
          form.vertical {
            grid-template-columns: 100%;
            grid-gap: 20px;
          }
          form.grid {
            grid-template-columns: auto auto;
            grid-gap: 20px;
          }
        `}</style>
      </form>
    );
  }
}

export {
  Button,
  Form,
  InputText,
  Label,
  InputCheckbox,
  InputGroup,
  InputPrepend,
  InputRadio,
  Select,
  Textarea,
};
